import { render, staticRenderFns } from "./SessionVideoSettings.vue?vue&type=template&id=58758977&scoped=true&"
import script from "./SessionVideoSettings.vue?vue&type=script&lang=js&"
export * from "./SessionVideoSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58758977",
  null
  
)

export default component.exports